import AdminAccessCodes from '@/pages/admin-access-codes/AdminAccessCodes';

export default AdminAccessCodes;
